export default __webpack_public_path__ + "static/blur-07f15d660455442621e0ea5f89d16288.png";